//cName stands for class name 
// Array of menu items to be displayed on the navbar 


export const MenuItems = [
    {
        title: 'Home',
        url: '/',
        Cname:'nav-links'
    },
    {
        title: 'About',
        url: '/about',
        Cname:'nav-links'
    },
    {
        title: 'Research',
        url: '/blog',
        Cname:'nav-links'
    },
    {
        title: 'FAQ',
        url: '/faq',
        Cname:'nav-links'
    },
    //Mobile pop out
    {
        title: 'Sign Up',
        url: '/contactForm',
        Cname:'nav-links'
    },
]